import moment from 'moment';
import * as Selector from './selectors';
import * as actions from './actions';

export default store => next => action => {
    return next(action);
};
